<template>
    <el-card>
        <div>{{ newCardPackParams.id ? `编辑卡包: ${newCardPackParams.id}` : "新增卡包" }}
            <CopyButton v-if="newCardPackParams.id" :text="newCardPackParams.id" />
        </div>
        <el-divider />
        <el-form :model="newCardPackParams" label-width="100px">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="名称" prop="name" required>
                        <el-input :disabled="!!newCardPackParams.id" v-model="newCardPackParams.name" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="描述" prop="desc">
                        <el-input v-model="newCardPackParams.desc" type="textarea" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="图片" prop="image">
                        <SingleImageUploader v-if="!newCardPackParams.id" v-model="newCardPackParams.image">
                        </SingleImageUploader>
                        <el-image v-else :src="newCardPackParams.image" fit="cover"
                            style="width: 100%; max-width: 210px; height: 280px; border-radius: 8px;" />
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24">
                    <el-form-item label="分类(可多选)" prop="categoryIds">
                        <el-checkbox-group v-model="newCardPackParams.categoryIds" fill="#409eff" size="small">
                            <el-checkbox-button v-for="item in cardCategoryStore.categories" :key="item.id"
                                :label="item.name" :value="item.id" />
                        </el-checkbox-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="标签(可多选)" prop="tagIds">
                        <el-checkbox-group v-model="newCardPackParams.tagIds" fill="#67c23a" size="small">
                            <el-checkbox-button v-for="item in cardTagStore.tags" :key="item.id" :label="item.name"
                                :value="item.id" />
                        </el-checkbox-group>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24">
                    <el-form-item label="稀有度(单选)" prop="rarity">
                        <el-radio-group v-model="newCardPackParams.rarity" fill="#e6a23c" size="small">
                            <el-radio-button v-for="r in rarities" :key="r" :label="r" :value="r" />
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="每包卡数" prop="cardCount" required>
                        <el-input v-model="newCardPackParams.cardCount" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="类型" prop="type">
                        <el-radio-group v-model="newCardPackParams.type" size="small">
                            <el-radio-button v-for="key in Object.keys(PACK_TYPE)" :key="key" :label="PACK_TYPE[key]"
                                :value="key" />
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="单次花费" prop="cost" required>
                        <el-input v-model="newCardPackParams.cost" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="10次花费" prop="cost10" required>
                        <el-input v-model="newCardPackParams.cost10" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="单次折后" prop="reduction" required>
                        <el-input v-model="newCardPackParams.reduction" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="10次折后" prop="reduction10" required>
                        <el-input v-model="newCardPackParams.reduction10" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="卡包总数" prop="total" required>
                        <el-input v-model="newCardPackParams.total" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="剩余卡包" prop="rest" required>
                        <el-input v-model="newCardPackParams.rest" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="显示EV" prop="expValue" required>
                        <el-input v-model="newCardPackParams.expValue" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="实际EV" prop="realExpValue">
                        <el-input disabled v-model="newCardPackParams.realExpValue" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="排序值" prop="sort">
                        <el-input-number v-model="newCardPackParams.sort" />
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-divider />
        <div>{{ "配置卡包内可抽取卡片" }} ({{ !imageSelectorParam.showForm ? '显示表格' : '显示图片' }}<el-switch
                v-model="imageSelectorParam.showForm" />)</div>
        <el-divider />

        <el-form v-if="!imageSelectorParam.showForm" :model="newCardPackParams.cards" label-width="100px">
            <template v-for="(card, index) in newCardPackParams.cards" :key="index">
                <el-row :gutter="20" align="top" class="card-config">
                    <el-col :span="6">
                        <el-badge :value="index + 1" type="primary">
                            <el-image :src="cardStore.cardsObj[card.cardId]?.image" fit="cover"
                                style="width: 100%;max-width: 210px; height: 280px; border-radius: 8px;" />
                        </el-badge>
                    </el-col>
                    <el-col :span="18">
                        <el-form :model="card" label-width="160px">
                            <el-form-item label="卡片名称(ID)">
                                {{ cardStore.cardsObj[card.cardId]?.name }} ({{ card.cardId }})
                                <el-link style="margin-left: 12px;" underline="always" type="primary"
                                    @click="deleteCard(index)">{{
                                        "删除"
                                    }}</el-link>
                            </el-form-item>
                            <el-form-item label="卡片稀有度(价值)">
                                {{ cardStore.cardsObj[card.cardId]?.rarity }} ({{ cardStore.cardsObj[card.cardId]?.value
                                }})
                            </el-form-item>
                            <el-form-item label="总数" required>
                                <el-input v-model="card.total" />
                            </el-form-item>
                            <el-form-item label="剩余" required>
                                <el-input v-model="card.rest" />
                            </el-form-item>
                            <el-form-item label="抽中概率" required>
                                <el-input :disabled="newCardPackParams.cards.length - 1 === index"
                                    v-model="card.drawRate" />
                            </el-form-item>
                            <el-form-item label="双爆概率" required>
                                <el-input v-model="card.doubleRate" />
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </template>
        </el-form>

        <el-table v-else :data="newCardPackParams.cards" border style="width: 100%; margin-top: 10px">
            <el-table-column label="操作" width="60" align="center">
                <template #default="{ $index }">
                    <el-link underline="always" type="primary" @click="deleteCard($index)">{{
                        "删除"
                        }}</el-link>
                </template>
            </el-table-column>
            <el-table-column label="Name" prop="name" width="180">
                <template #default="{ row }">
                    {{ cardStore.cardsObj[row.cardId]?.name }}
                </template>
            </el-table-column>
            <el-table-column label="稀有度" prop="rarity" width="80">
                <template #default="{ row }">
                    {{ cardStore.cardsObj[row.cardId]?.rarity }}
                </template>
            </el-table-column>
            <el-table-column label="价值" prop="value" width="80">
                <template #default="{ row }">
                    {{ cardStore.cardsObj[row.cardId]?.value }}
                </template>
            </el-table-column>
            <el-table-column label="总数">
                <template #default="{ row, $index }">
                    <el-input v-model="row.total" />
                </template>
            </el-table-column>
            <el-table-column label="剩余">
                <template #default="{ row, $index }">
                    <el-input v-model="row.rest" />
                </template>
            </el-table-column>
            <el-table-column label="抽中概率">
                <template #default="{ row, $index }">
                    <el-input :disabled="newCardPackParams.cards.length - 1 === $index" v-model="row.drawRate" />
                </template>
            </el-table-column>
            <el-table-column label="双爆概率">
                <template #default="{ row, $index }">
                    <el-input v-model="row.doubleRate" />
                </template>
            </el-table-column>
            <el-table-column label="ID" prop="cardId" width="180"></el-table-column>
        </el-table>

        <el-row>
            <el-col :span="6">
                <el-button type="primary" @click="addCard">
                    增加卡片<el-icon class="el-icon--right">
                        <Plus />
                    </el-icon>
                </el-button>
            </el-col>
        </el-row>

        <template #footer>
            <el-button @click="cancel">取消</el-button>
            <el-button v-if="!newCardPackParams.id" @click="resetAll">清空</el-button>
            <el-button v-if="!newCardPackParams.id" v-loading="newCardPackParams.loading" type="primary"
                @click="submitAddCard">新增</el-button>
            <el-button v-if="!!newCardPackParams.id" v-loading="newCardPackParams.loading" type="primary"
                @click="submitEditCard">保存</el-button>
        </template>
    </el-card>

    <!-- 图片选择弹窗 -->
    <el-dialog v-model="imageSelectorParam.showImageSelector" title="选择图片" width="600px" :close-on-click-modal="false">
        <div style="margin-bottom: 10px; display: flex; gap: 10px;">
            <el-input v-model="imageSelectorParam.searchName" clearable prefix-icon="Search" style="flex: 1;" />
            <el-select v-model="imageSelectorParam.rarity" class="level-select" placeholder="稀有度" clearable
                style="width: 100px">
                <el-option v-for="r in cardRarities" :key="r" :label="r" :value="r" />
            </el-select>
        </div>
        <div class="image-grid">
            <template v-for="card in filteredImages" :key="card.id">
                <div class="image-grid-inner"
                    :class="{ selected: imageSelectorParam.selectedImages.includes(card.id) }">
                    <el-image :src="card.image" fit="cover" class="image-option" @click="toggleSelect(card.id)" />
                    <span>{{ card.name }}</span>
                    <span>{{ card.rarity }}: {{ card.value }}</span>
                </div>
            </template>
        </div>
        <template #footer>
            <el-button @click="imageSelectorParam.showImageSelector = false">取消</el-button>
            <el-button @click="selectImage" type="primary">确定</el-button>
        </template>
    </el-dialog>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import { apiCall } from "@/utils/api";
import { PACK_TYPE } from "@/utils/constant";
import { useCardCategoryStore } from "@/stores/card/category";
import { useCardTagStore } from "@/stores/card/tag";
import { useCardStore } from "@/stores/card/card";

const cardCategoryStore = useCardCategoryStore();
const cardTagStore = useCardTagStore();
const cardStore = useCardStore();
const route = useRoute();
const router = useRouter();

const loading = ref(false);
const rarities = ref([]);
const cardRarities = ref([]);

const imageSelectorParam = reactive({
    showImageSelector: false,
    showForm: false,
    selectedImages: [],
    searchName: "",
    rarity: "",
});

const filteredImages = computed(() => {
    if (!imageSelectorParam.searchName && !imageSelectorParam.rarity) return cardStore.cards;
    const keyword = (imageSelectorParam.searchName || "").toLowerCase();
    const rarity = (imageSelectorParam.rarity || "").toLowerCase();
    const rtnCards = cardStore.cards.filter((card) => {
        let flg = true;
        if (keyword && !card.name.toLowerCase().includes(keyword)) {
            flg = false;
        }
        if (rarity && rarity !== card.rarity.toLowerCase()) {
            flg = false;
        }
        return flg;
    });
    return rtnCards;
});

const newCardPackParams = reactive({
    id: "",
    name: "",
    desc: "",
    image: "",
    categoryIds: [],
    tagIds: [],
    rarity: "",
    type: "gems",
    cardCount: 1,
    cost: 50,
    cost10: 500,
    reduction: 50,
    reduction10: 500,
    total: 0,
    rest: 0,
    expValue: 0,
    realExpValue: 0,
    sort: 50,
    cards: [],
});

watch(
    () => newCardPackParams.cost,
    (newCost) => {
        newCardPackParams.cost10 = newCost * 10;
        newCardPackParams.reduction = newCost;
        newCardPackParams.reduction10 = newCost * 10;
    }
);

watch(
    () => newCardPackParams.reduction,
    (newReduction) => {
        newCardPackParams.reduction10 = newReduction * 10;
    }
);

watch(
    () => newCardPackParams.categoryIds,
    (newIds) => {
        rarities.value = cardCategoryStore.packRarities(newIds);
        cardRarities.value = cardCategoryStore.cardRarities(newIds);
    }
);

function calcLastRate() {
    let totalRate = 0;
    let ev = 0;

    for (let index = 0; index < newCardPackParams.cards.length - 1; index++) {
        const card = newCardPackParams.cards[index];
        totalRate += 100 * card.drawRate;

        ev += cardStore.cardsObj[card.cardId].value * card.drawRate;
    }

    const lastCard = newCardPackParams.cards[newCardPackParams.cards.length - 1];
    lastCard.drawRate = (10000 - totalRate) / 100;
    ev += cardStore.cardsObj[lastCard.cardId].value * lastCard.drawRate;

    ev = ev / 100;

    newCardPackParams.expValue = newCardPackParams.expValue || ev.toFixed(2);
    newCardPackParams.realExpValue = ev.toFixed(2);
}

watch(
    () => newCardPackParams.cards.map(c => c.drawRate),
    () => {
        calcLastRate();
    },
    { deep: false }
);


async function loadData(id) {
    loading.value = true;
    const response = await apiCall("card.getCardPack", { id });
    if (!response) {
        loading.value = false;
        return false;
    }

    Object.keys(newCardPackParams).forEach(key => {
        newCardPackParams[key] = response[key];
    });

    loading.value = false;
}

async function resetAll() {
    newCardPackParams.loading = true;

    // newCardPackParams.id = "";
    newCardPackParams.name = "";
    newCardPackParams.desc = "";
    newCardPackParams.image = "";
    newCardPackParams.categoryIds = [];
    newCardPackParams.tagIds = [];
    newCardPackParams.rarity = "";
    newCardPackParams.type = "gems";
    newCardPackParams.cardCount = 0;
    newCardPackParams.cost = 50;
    newCardPackParams.cost10 = 500;
    newCardPackParams.reduction = 50;
    newCardPackParams.reduction10 = 500;
    newCardPackParams.total = 0;
    newCardPackParams.rest = 0;
    newCardPackParams.expValue = 0;
    newCardPackParams.realExpValue = 0;
    newCardPackParams.sort = 50;

    newCardPackParams.cards = [];

    newCardPackParams.loading = false;
}

function addCard() {
    imageSelectorParam.selectedImages = (newCardPackParams.cards || []).map(c => c.cardId);
    imageSelectorParam.showImageSelector = true;
}

function toggleSelect(cardId) {
    const existsIdx = imageSelectorParam.selectedImages.indexOf(cardId);
    if (existsIdx > -1) {
        imageSelectorParam.selectedImages.splice(existsIdx, 1);
    } else {
        imageSelectorParam.selectedImages.push(cardId);
    }
}

function selectImage() {
    newCardPackParams.cards = newCardPackParams.cards || [];
    const cardIds = newCardPackParams.cards.map(card => card.cardId);

    for (let idx = cardIds.length - 1; idx > -1; idx--) {
        if (imageSelectorParam.selectedImages.includes(cardIds[idx])) {
            continue;
        }
        cardIds.splice(idx, 1);
        newCardPackParams.cards.splice(idx, 1);
    }

    for (let cardId of imageSelectorParam.selectedImages) {
        if (cardIds.includes(cardId)) {
            continue;
        }
        const card = cardStore.cardsObj[cardId];
        if (!card) {
            continue;
        }
        newCardPackParams.cards.push({
            id: "",
            cardId: card.id,
            total: 0,
            rest: 0,
            drawRate: 0,
            doubleRate: 0,
        });
    }

    newCardPackParams.cards.sort((a, b) => {
        if (a.rarity === b.rarity) {
            return b.value - a.value;
        } else {
            return rarities.value.indexOf(a.rarity) - rarities.value.indexOf(b.rarity);
        }
    });
    imageSelectorParam.showImageSelector = false;
}

function deleteCard(index) {
    const dc = newCardPackParams.cards.splice(index, 1);
    if (dc.length > 0) {
        toggleSelect(dc[0].cardId)
    }
}

async function submitAddCard() {
    newCardPackParams.loading = true;

    const response = await apiCall("card.addCardPack", {
        name: newCardPackParams.name,
        desc: newCardPackParams.desc,
        image: newCardPackParams.image,
        categoryIds: newCardPackParams.categoryIds || [],
        tagIds: newCardPackParams.tagIds || [],
        rarity: newCardPackParams.rarity,
        type: newCardPackParams.type,
        cardCount: newCardPackParams.cardCount,
        cost: newCardPackParams.cost,
        cost10: newCardPackParams.cost10,
        reduction: newCardPackParams.reduction,
        reduction10: newCardPackParams.reduction10,
        total: newCardPackParams.total,
        rest: newCardPackParams.rest,
        sort: newCardPackParams.sort,
        expValue: newCardPackParams.expValue,
        realExpValue: newCardPackParams.realExpValue,
        cards: newCardPackParams.cards,
    });

    newCardPackParams.loading = false;
    if (!response) {
        return false;
    }
    ElMessageBox.alert("可在此基础上修改部分配置继续增加卡片，若要清空数据重新配置，请点击底部清空按钮！", "增加卡包成功!", {
        confirmButtonText: 'OK',
        callback: (action) => { },
    });

    return true;
}

async function submitEditCard() {
    newCardPackParams.loading = true;

    const response = await apiCall("card.modifyCardPack", {
        id: newCardPackParams.id,
        // name: newCardPackParams.name,
        desc: newCardPackParams.desc,
        // image: newCardPackParams.image,
        categoryIds: newCardPackParams.categoryIds || [],
        tagIds: newCardPackParams.tagIds || [],
        rarity: newCardPackParams.rarity,
        type: newCardPackParams.type,
        cardCount: newCardPackParams.cardCount,
        cost: newCardPackParams.cost,
        cost10: newCardPackParams.cost10,
        reduction: newCardPackParams.reduction,
        reduction10: newCardPackParams.reduction10,
        total: newCardPackParams.total,
        rest: newCardPackParams.rest,
        expValue: newCardPackParams.expValue,
        realExpValue: newCardPackParams.realExpValue,
        sort: newCardPackParams.sort,
        cards: newCardPackParams.cards,
    });

    newCardPackParams.loading = false;
    if (!response) {
        return false;
    }
    ElMessage.success("修改卡包成功");
    return router.go(-1);
}

function cancel() {
    return router.go(-1);
}

onMounted(async () => {
    await cardCategoryStore.getAll();
    await cardTagStore.getAll();
    await cardStore.getAll();
    if (route.params.id) {
        await loadData(route.params.id);
    }
});
</script>

<style scoped>
.basic-part .el-row {
    margin-bottom: 10px;
}

.image-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 10px;
}

.image-grid-inner {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
}

.image-grid-inner span {
    width: 100px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: center;
}

.image-grid-inner.selected {
    border-color: #409eff;
    box-shadow: 0 0 6px #a0cfff;
    border-radius: 4px;
    border: 1px solid #409eff;
}

.image-option {
    width: 100px;
    height: 140px;
    border-radius: 6px;
    object-fit: cover;
    cursor: pointer;
    transition: 0.2s;
}

.image-option:hover {
    transform: scale(1.05);
    box-shadow: 0 0 8px #ccc;
}

.card-config {
    padding: 12px;
    margin-bottom: 12px;
    border: 2px solid #dcdfe6;
    border-radius: 12px;
}
</style>
